import { PageTitleHelmet } from '@/components';
import JarFlyerboardProvider from '@/context/JarFlyerboardProvider';
import { useEffect } from 'react';
import { EventDetails, TrackingEvents, TrackingStage } from '@/config/tracking';
import { useAnalytics } from '@/hooks';
import { Jar } from './Jar';

export const JarContainer: React.FC = () => {
  const { trackEvent } = useAnalytics();
  useEffect(() => {
    trackEvent({
      event: TrackingEvents.viewFlyerSet,
      event_detail: EventDetails.viewFlyerSet('jar'),
      stage: TrackingStage.discovery,
    });
  }, []);

  return (
    <JarFlyerboardProvider>
      <PageTitleHelmet>Jar</PageTitleHelmet>
      <Jar />
    </JarFlyerboardProvider>
  );
};
